import { Link } from 'react-router-dom';

interface PageWrapperProps {
  children: React.ReactNode;
  heroImage: string;
  title: string;
  subtitle?: string;
}

export default function PageWrapper({ children, heroImage, title, subtitle }: PageWrapperProps) {
  return (
    <>
      <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
        <img
          src={heroImage}
          alt={title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm md:text-base text-white/80 max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </section>
      {children}
    </>
  );
}